import React, {  Component } from 'react';
import { connect } from 'react-redux';

class AddCustomerServiceNotesOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
			notes: '',
			errorMessage: ''
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog('AddCustomerServiceNotesOverlayDialog');
    }
	componentWillMount() {
		this.setState({
			notes: this.props.customerServiceNotes
        });
	}
	componentDidMount() {
		// window.scrollTo(0, 0);
		this.setState({
            showDialog: this.props.showDialog
        });
	}
	setNotes(event) {
		event.preventDefault();
		var value = event.target.value;
		if(value.length > 187) {
			value = value.substring(0, 187);
			event.target.value = value;
		}
		this.setState({
			notes: value
		})
	}
	handleAddNotes() {
		var notes = this.state.notes;
		this.setState({
			errorMessage: ''
		})
		if(notes) {
			this.props.handleAddNotes(notes);
		} else {
			this.setState({
				errorMessage: 'Please enter valid notes.'
			})
		}
	}
    render() {
        return (
			<div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="addCustomerServiceNotesOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Add Order Notes For Customer Service Review</h2>
                    <p>Adding notes will require customer service to review this order, which can affect your requested ship date or will call date.</p>
                    <p><b>Do not add notes here if you have requested SDS Next Day Delivery (M038 - Hot Shot).</b></p>
					<p className="bold red">{this.state.errorMessage}</p>
					{this.state.notes && this.state.notes.length === 187
						?<span className="bold red">We are sorry, notes to carrier is limited to 187 characters.</span>
						:null
					}
                    <textarea id="addCustomerServiceNotesTextfield" name="addCustomerServiceNotesTextfield" style={{width: '100%'}} onChange={this.setNotes.bind(this)} defaultValue={this.state.notes} />
                    <div className="noButtonContainer">
                      	<a className="noButton blueButton" onClick={this.closeDialog.bind(this)}>Cancel</a>
                    </div>
                    <div className="yesButtonContainer">
                      	<a className="yesButton blueButton" onClick={this.handleAddNotes.bind(this)}>Add Notes</a>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
   return {state};
};

AddCustomerServiceNotesOverlayDialog = connect(mapStateToProps)(AddCustomerServiceNotesOverlayDialog);
export default AddCustomerServiceNotesOverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/addCustomerServiceNotesOverlayDialog.js